import BottomSheet from '@components/LoungeEditor/BottomSheet';
import { Fragment } from 'react';

interface BottomActionSheetProps {
  open: boolean;
  onClose: () => void;
  btnInfos: {
    text: string;
    color?: string;
    isHide?: boolean;
    onClick: () => void;
  }[];
}

const BottomActionSheet: React.FC<BottomActionSheetProps> = (props) => {
  const { open, onClose, btnInfos } = props;
  return (
    <BottomSheet
      open={open}
      height={200}
      onClose={() => {
        onClose && onClose();
      }}
      style={{ backgroundColor: 'transparent' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-end',
          height: '200px',
          padding: '0 8px',
          paddingBottom: '20px',
        }}>
        <div style={{ width: '100%', borderRadius: '14px', overflow: 'hidden' }}>
          {btnInfos.map(
            (btnInfo, index) =>
              !btnInfo.isHide && (
                <Fragment key={index}>
                  <button
                    key={index}
                    style={{
                      height: '56px',
                      width: '100%',
                      color: btnInfo.color || '#007AFF',
                      border: 'none',
                      fontSize: '17px',
                      fontWeight: 400,
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      btnInfo.onClick && btnInfo.onClick();
                    }}>
                    {btnInfo.text}
                  </button>
                  {index !== btnInfos.length - 1 && (
                    <hr style={{ margin: 0, height: '0.333px', width: '100%', backgroundColor: '#E8EAED' }} />
                  )}
                </Fragment>
              ),
          )}
        </div>
        <button
          style={{
            marginTop: '8px',
            height: '56px',
            width: '100%',
            fontSize: '17px',
            color: '#007AFF',
            fontWeight: 600,
            borderWidth: 0,
            borderRadius: '14px',
            cursor: 'pointer',
          }}
          onClick={() => {
            onClose && onClose();
          }}>
          취소
        </button>
      </div>
    </BottomSheet>
  );
};

export default BottomActionSheet;
